import { render, staticRenderFns } from "./MacroCard.vue?vue&type=template&id=14b2fcfb&scoped=true&"
import script from "./MacroCard.vue?vue&type=script&lang=ts&"
export * from "./MacroCard.vue?vue&type=script&lang=ts&"
import style0 from "./MacroCard.vue?vue&type=style&index=0&id=14b2fcfb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b2fcfb",
  null
  
)

export default component.exports